import { QueryFn } from '@percent/education-hosted-form/hooks/useQuery/useQuery.types'
import { GetPartnerConfigParams, PartnerConfigResponse } from './partnerConfig.types'

export const getPartnerConfigAction: QueryFn<[string, GetPartnerConfigParams], PartnerConfigResponse> = async (
  client,
  [_, args]
) => {
  const response = await client.get(`v1/validation-invites/${args.programId}/hosted-form-detail`)

  return response.data
}
